import { AlertTriangle } from "lucide-react";

export default function DeclassementBadge({ taux, seuil = 5, testId }) {
  const alerte = taux > seuil;
  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-lg px-3 py-1.5 font-mono font-bold ${
        alerte ? "bg-rose-600 text-white animate-pulse" : "bg-emerald-100 text-emerald-800"
      }`}
    >
      {alerte && <AlertTriangle className="w-4 h-4" />}
      {taux.toFixed(1)} %
    </div>
  );
}
